import { scene } from '../main/scene-sidecar'
import { l } from '../lib/imports'
import { tileMapShip } from './tileMapShip-sidecar'
import { tilesShip } from './tilesShip-sidecar'
import { tilesDataShip } from './tilesDataShip-sidecar'

export interface ISavedTile {
  i: number
  j: number
  f: number
  w: number
  s: number
  o: number
  //d: number
}

export function save(): ISavedTile[] {
  let ctx = scene.getContext()

  let sd: ISavedTile[] = []

  l.forEach(ctx.mapShip.tiles, (c) => {
    sd.push({
      i: c.i,
      j: c.j,
      f: c.dataFloor ? c.dataFloor.idx : 0,
      w: c.dataStructure ? c.dataStructure.idx : 0,
      s: c.dataShadow ? c.dataShadow.idx : 0,
      o: c.dataObject ? c.dataObject.idx : 0,
    })
  })

  return sd
}

export function load(sd: ISavedTile[]) {
  let ctx = scene.getContext()
  let { mapShip } = ctx

  l.forEach(sd, (c) => {
    let s = c as ISavedTile
    // console.log(s.i, s.j)

    let t = tileMapShip.getTile(mapShip, s.i, s.j)
    if (t) {
      tilesShip.setFloor(t, tilesDataShip.getByIndex(s.f))
      tilesShip.setStructure(t, tilesDataShip.getByIndex(s.w))
      tilesShip.setShadow(t, tilesDataShip.getByIndex(s.s))
      tilesShip.setObject(t, tilesDataShip.getByIndex(s.o))
    }
  })
}
